<script>
export default {
  data: () => ({
    label: undefined
  }),
  mounted() {
    if (this.modelValue && this.checkValue) {
      this.checkValue(this.modelValue)
    }

    if (this.filledCheck && this.modelValue)
      this.filledCheck()
    if (this.$el.classList.contains('aoformlabel'))
      this.label = this.$el
    else
      this.label = this.$el.querySelector('.aoformlabel')
    if (!this.label) {
      if (this.$el.classList.contains('formlabel'))
        this.label = this.$el
      else
        this.label = this.$el.querySelector('.formlabel')
    }
    if (!this.label) {
      if (this.$el.classList.contains('tagscontainer'))
        this.label = this.$el
      else
        this.label = this.$el.querySelector('.tagscontainer')
    }
    if (!this.label) return
    if (this.modelValue && (Array.isArray(this.modelValue) ? this.modelValue.length : true))
      this.label.classList.add('filled')
    else
      this.label.classList.remove('filled')
  },
  unmounted() {
    this.$emit('setError', '')
    try {
      this.$emit('update:modelValue', '')
      //eslint-disable-next-line
    } catch (err) {
    }
  },
  watch: {
    modelValue(val) {
      if (!this.label) return
      if (val && (Array.isArray(val) ? val.length : true))
        this.label.classList.add('filled')
      else
        this.label.classList.remove('filled')
    },
    error(v) {
      this.$emit('setError', v)
    }
  }
}
</script>

<style lang="sass">
.aoformfield
  display: block
  width: 100%
  border: none
  letter-spacing: globalvars.$onespacing
  border-bottom: 1px solid colors.$moar_silver_for_the_god_of_silver
  transition: border-color .3s ease-out
  font-size: 16px
  line-height: 26px
  color: colors.$brownfont
  outline: none
  background: none
  resize: none
  &:focus, &:focus-visible
    border-bottom: 1px solid colors.$newgray
  &.active 
    border-bottom: 1px solid colors.$newgray
    box-shadow: 0px 2px 0px -1px colors.$newgray
  &[disabled],&[readonly]
    pointer-events: none
  &_pointer
    cursor: pointer
  &_alignright:not(:focus)
    direction: rtl
    text-align: left
  &_witharrow
    display: flex
    justify-content: space-between
    align-items: center
    svg
      min-width: 10px
      margin: 10px
      margin-right: 8px
      margin-left: 15px
      cursor: pointer
.aoformlabel__error:not(:empty)~.aoformfield:not(:focus)
  border-bottom: 1px solid colors.$newred !important
  
.formfield
  border: none
  outline: none
  background: none
  display: block
  width: 100%
  text-align: left
  font-size: 16px
  line-height: 26px
  min-height: 26px
  color: colors.$brownfont
  padding: 1px 0 0
  &_pointer
    cursor: pointer
    position: relative
    z-index: 2
    &::before
      content: ''
      position: absolute
      left: 0
      top: -10px
      right: 0
      bottom: 0
  &::placeholder
    color: colors.$newgray
  &[disabled], &[readonly]
    pointer-events: none
  &_witharrow
    display: flex
    justify-content: space-between
    align-items: center
    svg
      flex-shrink: 0
      margin: -10px 1px 10px 15px
      cursor: pointer
      &:first-child
        margin-left: auto  
</style>